import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import styles from "./PresetCr.module.scss";
import Axios from "../../../../_services/caller.service";
import { AiOutlineClose, AiOutlineExclamationCircle } from "react-icons/ai";
import { FiDownload, FiUpload, FiRefreshCw, FiSave } from "react-icons/fi";
import download from "downloadjs";

import Loader from "../../../UiComponents/loader/Loader";
import ModalConfirmNewPreset from "../modal/ModalConfirmNewPreset";
import SortableTest from "../sortable/SortablePreset";
import { PermissionGate } from "../../../superAdmin/managePermissions/PermissionGate";

const PresetCr = ({ userId, setOverlay }) => {
  const { t } = useTranslation();
  const [presetCr, setPresetCr] = useState([]);
  const [displayDescription, setDisplayDescription] = useState(null);

  const [maj, setMaj] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSucess] = useState(false);

  const [selectedFile, setSelectedFile] = useState();
  const [modalConfirmNewPreset, setModalConfirmNewPreset] = useState(false);
  const [isNotGoodImportFileType, setIsNotGoodImportFileType] = useState(false);

  useEffect(() => {
    if (userId !== "") {
      Axios.get(`/presetCr/${userId}`)
        .then(function async(response) {
          setPresetCr(response.data.data);
          setIsNotGoodImportFileType(false);
        })
        .catch(function (error) {
          toast.error(t("preset.load_error"));
        });
    }
  }, [userId, maj]);

  const exportSelectedCards = () => {
    const dataStr = JSON.stringify(presetCr);
    const filename = `Presets-PDF-id-${userId}.txt`;
    const filetype = "text/plain";
    download(dataStr, filename, filetype);
  };

  const importPresetTest = () => {
    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const text = e.target.result;
        const data = JSON.parse(text);
        if (
          !Array.isArray(data) ||
          data.length === 0 ||
          !data[0]?.preset ||
          !data[0].preset.includes("<PDFPreset>")
        ) {
          setIsNotGoodImportFileType(true);
          toast.error(t("preset.wrong_preset_type"));
          setSelectedFile(undefined);
          return;
        }
        setPresetCr([...presetCr, ...data]);
        setIsNotGoodImportFileType(false);
      } catch (err) {
        setIsNotGoodImportFileType(true);
        toast.error(t("preset.wrong_preset_type"));
      }
      setSelectedFile(undefined);
    };
    reader.readAsText(selectedFile, "ISO-8859-1");
  };

  const fileChangedHandler = (file) => {
    setSelectedFile(file);
  };

  useEffect(() => {
    if (selectedFile) {
      importPresetTest();
    }
  }, [selectedFile]);

  const activeModalConfirm = () => {
    setOverlay(true);
    setModalConfirmNewPreset(true);
  };

  const registerNewPreset = () => {
    Axios.put(`/updatePresetCr/${userId}`, {
      data: presetCr,
    })
      .then((response) => {
        setLoading(false);
        setSucess(true);
        toast.success(t("preset.save_success"));
        setTimeout(() => {
          setSucess(false);
          setModalConfirmNewPreset(false);
          setOverlay(false);
        }, 1500);
      })
      .catch(function (error) {
        setLoading(false);
        toast.error(t("preset.save_error"));
      });
  };

  return (
    <div className={styles.card}>
      <h3 className={styles.cardTitle}>{t("preset.preset_reports")}</h3>

      <div className={styles.controls}>
        <PermissionGate actionKey="presetCR.export">
          <button
            type="button"
            className={styles.btnGhost}
            onClick={exportSelectedCards}
          >
            <FiDownload /> {t("preset.export")}
          </button>
        </PermissionGate>

        <label className={styles.fileLabel}>
          <FiUpload /> {t("preset.import")}
          <PermissionGate actionKey="presetCR.import">
            <input
              type="file"
              onChange={(e) => fileChangedHandler(e.target.files[0])}
              hidden
            />
          </PermissionGate>
        </label>

        <button
          type="button"
          className={styles.btnGhost}
          onClick={() => setMaj(!maj)}
        >
          <FiRefreshCw /> {t("common.refresh")}
        </button>
      </div>

      {isNotGoodImportFileType && (
        <div className={styles.alertWarning}>
          <AiOutlineExclamationCircle />
          <span>{t("preset.wrong_preset_type")}</span>
          <AiOutlineClose
            onClick={() => setIsNotGoodImportFileType(false)}
            className={styles.alertClose}
          />
        </div>
      )}

      <SortableTest
        presetType={presetCr}
        setPresetType={setPresetCr}
        displayDescription={displayDescription}
        setDisplayDescription={setDisplayDescription}
      />

      <div className={styles.saveBar}>
        <PermissionGate actionKey="presetCR.update">
          <button
            type="button"
            className={styles.btnPrimary}
            onClick={activeModalConfirm}
          >
            <FiSave /> {t("Enregistrer les changements")}
          </button>
        </PermissionGate>
      </div>

      {modalConfirmNewPreset && (
        <ModalConfirmNewPreset
          setOverlay={setOverlay}
          setModalConfirmRegisterNewPreset={setModalConfirmNewPreset}
          registerNewValue={registerNewPreset}
          success={success}
        />
      )}
      {loading && <Loader />}
    </div>
  );
};

export default PresetCr;
